import axios from 'axios';
import { startDesktopSync } from './desktop/sync';

export const url = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: url,
});

startDesktopSync(api);

export default api;
